/**
 * Tap tempo actions on the shared session (W2-08 timing): the `timing.tap` command (B) and the Tap button add a
 * tap at the current performance time; Use and Reset clear the series.
 */

import type { AppServices } from '../../app/registry/types';
import { addTap, EMPTY_TAPS, readTaps, type TapReading } from './timingModel';
import { timingSessionFor } from './timingSession';

/** Clock of the taps (ms); replaceable in tests. */
export const tapClock: { now: () => number } = { now: () => performance.now() };

/** Adds a tap now and returns the reading. */
export function tapNow(services: Pick<AppServices, 'editor'>): TapReading {
  const session = timingSessionFor(services);
  const taps = addTap(session.get().taps, tapClock.now());
  session.set({ taps });
  return readTaps(taps);
}

export function resetTaps(services: Pick<AppServices, 'editor'>): void {
  timingSessionFor(services).set({ taps: EMPTY_TAPS });
}

/** The current reading (null BPM before 4 taps). */
export function tapReading(services: Pick<AppServices, 'editor'>): TapReading {
  return readTaps(timingSessionFor(services).get().taps);
}
